export const COLOR_PALETTE = {
  // Backgrounds — blue-teal charcoal, deliberately away from purple
  background: '#0e161c',
  backgroundStripe: '#121a21',

  // Player 1 (Blue)
  player1: '#22f8df',
  player1Border: '#1bc4b0',
  player1Score: '#4fffe8',
  player1GridLine: '#1a2a2a',
  player1Food: '#158f7f',

  // Player 2 (Purple)
  player2: '#cc66ff',
  player2Border: '#9933cc',
  player2Score: '#d98aff',
  player2GridLine: '#2a1a2a',
  player2Food: '#8833b3',

  // Player 3 (Green)
  player3: '#33ff66',
  player3Border: '#22cc44',
  player3Score: '#66ff88',
  player3GridLine: '#1a2a1a',
  player3Food: '#1a9934',

  // Player 4 (Pink)
  player4: '#ff66b2',
  player4Border: '#cc3388',
  player4Score: '#ff8acc',
  player4GridLine: '#2a1a22',
  player4Food: '#b33378',

  // Racing Food
  racingFood: '#ffff33',

  // Neon Accents
  neonCyan: '#00ffff',
  neonMagenta: '#ff00ff',
  neonYellow: '#ffff33',
  neonRed: '#ff3366',
  targetSelected: '#ff9f1a',

  // Power-up Colors
  powerupSpeed: '#00bfff',
  powerupShield: '#66ffcc',
  powerupFlip: '#ff33cc',
  powerupDebuff: '#ff4444',
  // Variant tint: blue = applies to self (player), red = sent to opponent
  powerupPlayer: '#00bfff',
  powerupOpponent: '#ff4444',

  // UI Elements
  timerText: '#00ffff',
  scoreText: '#ffffff',
  gridLine: '#2a2a2a',

  // Progress Bar
  progressEmpty: '#333333',
  progressFilled: '#00ffcc',

  // Attack Blocks
  obstacleHighlight: '#ff3366',
  obstacleSolid: '#8b0000',
} as const;
